// Tyler.Api.Metadata.Align
export enum Align {
    Left = 0,
    Center = 1,
    Right = 2
}
